import React, { useEffect, useState } from 'react';
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import { IoSearchOutline } from 'react-icons/io5';
import { HiOutlineArrowLeft } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { useAllinvestorsQuery } from '../../../store/services/investorService';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import Manager_web_portal from '../../../layout/Manager_web_portal';
import * as XLSX from 'xlsx';
import ViewSlip from '../CompanyExpense/ViewSlip';
import { Base_url } from '../../../utils/Base_url';
import { InvestorsTableSkeleton } from '../../../components/Skeleton';

const PAGE_LIMIT = 8;

const Investors = () => {
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [getData, setGetData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState('active');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
      setCurrentPage(1);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter]);

  const { data, isLoading, isFetching } = useAllinvestorsQuery(
    {
      page: currentPage,
      limit: PAGE_LIMIT,
      search: debouncedSearch,
      status: statusFilter
    },
    { placeholderData: (previousData) => previousData }
  );

  const currentPageData = Array.isArray(data?.investors) ? data.investors : [];
  const totalItems = data?.total ?? 0;
  const totalPages = Math.max(1, data?.totalPages ?? 1);
  const showSkeleton = isLoading || (isFetching && currentPageData.length === 0);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages || isFetching) return;
    setCurrentPage(newPage);
  };

  const ExportCVC = async (item) => {
    try {
      if (!item?.cnic) {
        console.error('Invalid CNIC provided.');
        return;
      }

      const response = await fetch(
        `${Base_url}/v1/manager/investor-all-details/${item?.cnic}`,
        { method: 'GET', redirect: 'follow' }
      );

      if (!response.ok) {
        console.error('Failed to fetch data:', response.statusText);
        return;
      }

      const result = await response.json();
      const investorDetails = result?.investorDetails;
      const enrolledPlans = investorDetails?.enrolledPlans;

      if (!investorDetails || !Array.isArray(enrolledPlans)) {
        console.error('Invalid data structure.');
        return;
      }

      const investorData = {
        'Investor Name': investorDetails?.investorName?.fullName,
        CNIC: investorDetails?.investorName?.cnic,
        'Contact Info': investorDetails?.investorName?.contactInfo,
        Password: investorDetails?.investorName?.password,
        'Bio Status': investorDetails?.investorName?.bioStatus,
        'Created At': investorDetails?.investorName?.createdAt,
        Images: investorDetails?.investorName?.images
      };

      const dataForExport = [investorData];

      enrolledPlans.forEach((plan) => {
        plan.investments.forEach((investment) => {
          dataForExport.push({
            'Plan Category': plan.planCategory,
            'Plan Name': plan.planName,
            'Deposit Date': investment.depositDate,
            'Deposit Type': investment.depositType,
            'Receipt Number': investment.receiptNumber,
            Amount: investment.amount,
            'Bank Name': investment.bankName,
            'Branch Name': investment.branchName,
            Reference: investment.reference,
            Remark: investment.remark,
            'Acknowledge Auth': investment.acknowledgeAuth,
            'Acknowledge Date': investment.acknowledgeDate,
            'Acknowledge Status': investment.acknowledgeStatus,
            Deduction: investment.deduction,
            Profit: investment.profit,
            Slip: investment.slip
          });
        });
      });

      const ws = XLSX.utils.json_to_sheet(dataForExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Investor Data');
      XLSX.writeFile(wb, `Investor_${investorDetails?.investorName?.fullName}.xlsx`);
    } catch (error) {
      console.error('Error exporting data:', error);
    }
  };

  return (
    <Manager_web_portal
      language={
        <>
          <p className=" sm:block  hidden">English | Urdu</p>
        </>
      }
      ToggleBtn={
        <div className=" flex gap-4 items-center">
          <HiOutlineArrowLeft />
          <h2 className="">Investors</h2>
        </div>
      }
      title_props={
        <>
          <div className=" w-96 relative">
            <Input
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={''}
              className={' border bg-white w-full rounded-full'}
            />

            <Button
              Icon={<IoSearchOutline className=" text-white text-xl" />}
              label={'search'}
              className={
                ' absolute top-0 right-0 bg-secondary  text-white uppercase font-normal rounded-full'
              }
            />
          </div>
        </>
      }
    >
      <div className="  w-full  mb-4  sm:hidden block relative">
        <Input
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={''}
          className={' border bg-white w-full rounded-full'}
        />

        <Button
          Icon={<IoSearchOutline className=" text-white text-xl" />}
          label={'search'}
          className={
            ' absolute top-0 right-0 bg-secondary text-white uppercase font-normal rounded-full'
          }
        />
      </div>
      <div className=" sm:flex block    justify-between items-center">
        <div>
          <h2 className="  sm:block hidden">Investors</h2>
          <p className="text-sm text-gray-500 mt-1">
            {isFetching && !showSkeleton
              ? 'Updating...'
              : `${totalItems} investor${totalItems !== 1 ? 's' : ''} found`}
          </p>
        </div>

        <div className=" flex gap-3 items-center"></div>
      </div>

      <div className="flex flex-wrap gap-2 mt-4 mb-2">
        {[
          { key: 'all', label: 'All' },
          { key: 'active', label: 'Active' },
          { key: 'inactive', label: 'Inactive' }
        ].map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => setStatusFilter(item.key)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-colors ${
              statusFilter === item.key
                ? 'bg-secondary text-white border-secondary'
                : 'bg-white text-gray-600 border-gray-300 hover:border-secondary hover:text-secondary'
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      <section className="mb-20 mt-7 text-gray-800">
        <div className="block rounded-lg ">
          <div className="flex flex-col overflow-x-auto">
            <div className=" sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full sm:px-6 lg:px-8">
                <div className="overflow-hidden">
                  <table className="min-w-full mb-0">
                    <thead className=" ">
                      <tr className=" rounded-lg whitespace-nowrap ">
                        <th scope="col" className=" text-sm  text-darkGray  font-medium px-6">
                          Name
                        </th>
                        <th scope="col" className=" text-sm text-darkGray    font-medium px-6 ">
                          Phone Number
                        </th>
                        <th scope="col" className=" text-sm text-darkGray    font-medium px-6 ">
                          CNIC No
                        </th>

                        <th scope="col" className="text-sm  text-darkGray   font-medium px-6 ">
                          CNIC Copy
                        </th>

                        <th scope="col" className="text-sm  text-darkGray     font-medium px-6 ">
                          Password
                        </th>
                        <th scope="col" className="text-sm  text-darkGray     font-medium px-6 ">
                          Export
                        </th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {showSkeleton ? (
                        <InvestorsTableSkeleton rows={PAGE_LIMIT} showActions />
                      ) : currentPageData.length > 0 ? (
                        currentPageData.map((item) => (
                          <tr
                            key={item._id}
                            className="bg-white border-t-8 border-b-8    border-[#F6F6F6]  rounded-md "
                          >
                            <th
                              scope="row"
                              className="text-sm font-normal px-6 py-4   whitespace-nowrap "
                            >
                              <Link
                                onClick={() => localStorage.setItem('iName', item?.fullName)}
                                to={`/manager/investorsDetails/${item?.cnic}/${item?._id}`}
                                className="mb-0.5 font-medium  text-secondary"
                              >
                                {item?.fullName}
                              </Link>
                            </th>
                            <td className="align-middle text-sm font-normal px-6 py-4 whitespace-nowrap  text-center">
                              <span className=" text-base text-black  py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline   bg-green-200  rounded-full">
                                {item?.contactInfo}
                              </span>
                            </td>
                            <td className="align-middle text-sm font-normal px-6 py-4 whitespace-nowrap  text-center">
                              <span className=" text-base text-black  py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline   bg-green-200  rounded-full">
                                {item?.cnic}
                              </span>
                            </td>

                            <td className=" cursor-pointer align-middle text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span
                                onClick={() => {
                                  setIsModalOpen2(true);
                                  setGetData(item);
                                }}
                                className=" text-base text-secondary  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full"
                              >
                                {item?.images?.slice(-6)}
                              </span>
                            </td>
                            <td className="align-middle text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                {item?.password}
                              </span>
                            </td>
                            <td className="align-middle text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <button
                                className="bg-secondary text-white px-4 py-2 rounded-md"
                                onClick={() => ExportCVC(item)}
                              >
                                Export
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="px-6 py-12 text-center text-gray-500">
                            No investors found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {!showSkeleton && totalItems > 0 && (
            <div className=" flex justify-end items-center  py-4 gap-6">
              <button
                className={`${
                  currentPage === 1 || isFetching
                    ? 'bg-gray-500  text-white'
                    : 'bg-secondary text-white'
                } flex justify-center items-center  w-10 h-10 rounded-md`}
                disabled={currentPage === 1 || isFetching}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                <FaAngleLeft size={20} />
              </button>
              <span className="  text-primary  font-semibold">
                {currentPage} of {totalPages}
                <span className="text-gray-400 font-normal text-sm ml-2">
                  ({totalItems} total)
                </span>
              </span>
              <button
                className={`${
                  currentPage >= totalPages || isFetching
                    ? 'bg-gray-500  text-white'
                    : 'bg-secondary text-white'
                } flex justify-center items-center  w-10 h-10 rounded-md`}
                disabled={currentPage >= totalPages || isFetching}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                <FaAngleRight size={20} />
              </button>
            </div>
          )}
        </div>
      </section>
      <ViewSlip isModalOpen={isModalOpen2} setIsModalOpen={setIsModalOpen2} images={getData} />
    </Manager_web_portal>
  );
};

export default Investors;
